import { Link } from 'react-router-dom';
import HlsPlayer from './HlsPlayer';
import type { Camera } from '../lib/api';

interface Props {
  camera: Camera;
}

export default function CameraTile({ camera }: Props) {
  const isLive = camera.status === 'live';

  return (
    <Link
      to={`/camera/${camera.id}`}
      className="bracketed"
      style={{
        display: 'block',
        background: 'var(--background)',
        textDecoration: 'none',
        color: 'inherit',
      }}
    >
      <div style={{ position: 'relative', aspectRatio: '16 / 9', overflow: 'hidden', background: '#0A0A0A' }}>
        {isLive ? (
          <HlsPlayer src={camera.hls_url} />
        ) : (
          <div className="mono" style={{
            display: 'grid', placeItems: 'center', height: '100%', color: 'var(--muted)', fontSize: 12,
          }}>
            ▸ {camera.status.toUpperCase()}
          </div>
        )}

        {/* status overlay top-left */}
        <div className="mono" style={{
          position: 'absolute', top: 8, left: 10, fontSize: 10, letterSpacing: '0.15em',
          color: '#F5F3EE', textShadow: '0 1px 2px rgba(0,0,0,0.6)',
        }}>
          <span className="dot dot-pulse" style={{ background: isLive ? 'var(--orange)' : 'var(--muted)' }} />
          {isLive ? 'LIVE' : camera.status.toUpperCase()}
        </div>
      </div>

      <div style={{
        padding: '0.75rem 1rem 1rem',
        borderTop: '1px solid var(--grid-line)',
      }}>
        <div className="mono eyebrow" style={{ marginBottom: 4 }}>{camera.id}</div>
        <div style={{ fontWeight: 700, fontSize: 14 }}>{camera.name}</div>
        <div className="mono" style={{ fontSize: 11, color: 'var(--muted)', marginTop: 2 }}>
          {camera.location}
        </div>
      </div>
    </Link>
  );
}
